// src/components/Header/index.jsx
import React from 'react';
import { Layout, Menu, Avatar, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useUser } from '../../utils/userContext.js';
import './index.css';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const { user, logout } = useUser();

  const menuItems = [
    { key: 'home', label: <Link to="/">首页</Link> },
    { key: 'archive', label: <Link to="/archive">归档</Link> },
    { key: 'writepost', label: <Link to="/write-post">写文章</Link> },
    { key: 'about', label: <Link to="/about">我的</Link> },
  ];

  const handleMenuClick = (e) => {
    // 菜单点击事件现在通过 Link 处理，无需手动跳转
  };

  return (
    <AntHeader className="blog-header">
      <div className="blog-header-title">我的博客</div>
      
      <Menu 
        className="blog-header-menu"
        mode="horizontal" 
        items={menuItems} 
        selectedKeys={['about']} // 默认选中"我的"页面
        onClick={handleMenuClick}
      />
      
      {user && (
        <div className="blog-header-user">
          <Avatar 
            src="https://tu.tuhenmei.com/zb_users/upload/2023/06/20230613168661723.png" 
            className="user-avatar" 
            alt="User Avatar"
          />
          <Text className="user-name">欢迎, {user.username}</Text>
          <button 
            className="logout-button"
            onClick={logout}
          >
            登出
          </button>
        </div>
      )}
    </AntHeader>
  );
};

export default AppHeader;